import React from 'react';

function TopNav({ view, savedCount, onBrandClick, onIngredientsClick, onSavedClick }) {
  return (
    <nav className="top-nav">
      <button className="nav-brand" onClick={onBrandClick}>Recipe Costing</button>
      <div className="nav-actions">
        <button
          className={`nav-btn ${view === 'ingredients' ? 'active' : ''}`}
          onClick={onIngredientsClick}
        >
          Ingredients
        </button>
        <button
          className={`nav-btn ${view === 'saved' ? 'active' : ''}`}
          onClick={onSavedClick}
        >
          Saved
          {savedCount > 0 && <span className="nav-badge">{savedCount}</span>}
        </button>
      </div>
    </nav>
  );
}

export default TopNav;
